import React from "react";
import { Ban, CircleCheck, Pencil, Trash2 } from "lucide-react";

import { Pill, PILL_COLORS } from "components/ui/Pill";

import styles from "./ServiceDetailsPage.module.css";

export const useServiceColumns = ({ onEdit, onDelete, onToggleClick }) => {
  const columns = [
    {
      key: "name",
      header: "Name",
      flexGrow: 2,
      render: (row) => row.name,
    },
    {
      key: "color",
      header: "Color",
      render: (row) => (
        <div className={styles.colorSwatch}>
          <div
            className={styles.colorSwatchBox}
            style={{ backgroundColor: row.color || "#006546" }}
          />
          <span className={styles.colorSwatchLabel}>
            {row.color || "#006546"}
          </span>
        </div>
      ),
    },
    {
      key: "price",
      header: "Price",
      render: (row) => <strong>€{row.price}</strong>,
    },
    {
      key: "duration",
      header: "Duration",
      render: (row) => `${row.duration} min`,
    },
    {
      key: "status",
      header: "Status",
      render: (row) => (
        <Pill {...(row.disabled ? PILL_COLORS.sentNo : PILL_COLORS.sentYes)}>
          {row.disabled ? "Disabled" : "Enabled"}
        </Pill>
      ),
    },
  ];

  const rowActions = [
    {
      label: "Edit",
      icon: Pencil,
      primary: true,
      onClick: (row) => onEdit(row.id),
    },
    {
      label: "Enable",
      icon: CircleCheck,
      primary: true,
      visibleWhen: (row) => row.disabled,
      onClick: (row) => onToggleClick(row),
    },
    {
      label: "Disable",
      icon: Ban,
      primary: true,
      visibleWhen: (row) => !row.disabled,
      onClick: (row) => onToggleClick(row),
    },
    {
      label: "Delete",
      icon: Trash2,
      primary: true,
      onClick: (row) => onDelete(row),
    },
  ];

  return { columns, rowActions };
};
